// extracted by mini-css-extract-plugin
module.exports = {"container":"task-view__container___2J8av"};